export default __webpack_public_path__ + "static/media/credit.99fad554.svg";